import { imgs } from "../assets/imgs";
import { baseSubTeamActivity } from "./initActivityTasks";

export const tasksId = {
	tema1: {
		id: 1,
		title: "Piso de Venta",
		activities: {
			subtema1: "T1_subtema1",
			subtema2: "T1_subtema2",
			subtema3: "T1_subtema3",
			subtema4: "T1_subtema4",
			subtema5: "T1_subtema5",
			subtema6: "T1_subtema6",
			subtema7: "T1_subtema7",
		},
	},
	tema2: {
		id: 2,
		title: "Roller y máquina café",
		activities: {
			subtema1: "T2_subtema1",
			subtema2: "T2_subtema2",
		},
	},
	tema3: {
		id: 3,
		title: "Limpieza y merma",
		activities: {
			subtema1: "T3_subtema1",
			subtema2: "T3_subtema2",
			subtema3: "T3_subtema3",
		},
	},
	tema4: {
		id: 4,
		title: "Conceptos caja",
		activities: {
			subtema1: "T4_subtema1",
			subtema2: "T4_subtema2",
			subtema3: "T4_subtema3",
			subtema4: "T4_subtema4",
			subtema5: "T4_subtema5",
			subtema6: "T4_subtema6",
		},
	},
	tema5: {
		id: 5,
		title: "Servicios financieros",
		activities: {
			subtema1: "T5_subtema1",
			subtema2: "T5_subtema2",
			subtema3: "T5_subtema3",
			subtema4: "T5_subtema4",
		},
	},
	tema6: {
		id: 6,
		title: "Servicios electrónicos",
		activities: {
			subtema1: "T6_subtema1",
			subtema2: "T6_subtema2",
			subtema3: "T6_subtema3",
			subtema4: "T6_subtema4",
			subtema5: "T6_subtema5",
		},
	},
	tema7: {
		id: 7,
		title: "Venta responsable",
		activities: {
			subtema1: "T7_subtema1",
			subtema2: "T7_subtema2",
		},
	},
	tema8: {
		id: 8,
		title: "Protección patrimonial",
		activities: {
			subtema1: "T8_subtema1",
			subtema2: "T8_subtema2",
		},
	},
	tema9: {
		id: 9,
		title: "SASSO",
		activities: {
			subtema1: "T9_subtema1",
		},
	},
};

const activitiesInformationTeamOne = {
	T1_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Imagen de la Tienda",
		subtitle:
			"Te conviertes en el gerente de una tienda y debes asegurarte de que la imagen de la tienda sea atractiva para los diferentes tipos de clientes que visitan tu negocio.",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 45,
		numberOfTask: 5,
		isOpen: true,
		nextActivity: tasksId.tema1.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: true,
				title: "Viste al personaje de acuerdo al código de vestimenta de Oxxo.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema1/activitytwo",
				title: "Recorre la tienda y conoce las distintas áreas que la componen.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema1/activitythree",
				title: "Identifica los distintos tipos de Oxxo y los elementos que lo caracterizan.",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 5,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema1/activityfour",
				title: "Recorre la ciudad y localiza tu tipo de tienda Oxxo.",
			},
			{
				id: 5,
				imgTask: imgs.imgActividad,
				points: 30,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema1/activityfive",
				title: "Conoce e identifica los diferentes Tipos de clientes.",
			},
		],
	},
	T1_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Abasto en tienda",
		points: 15,
		numberOfTask: 3,
		nextActivity: tasksId.tema1.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 5,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema2/activityOne",
				title: "Limpieza en tienda.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema2/activityTwo",
				title: "Frenteo, fondeo, acomodo y PEPS.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema2/activityThree",
				title: "Metodología 5’s +1.",
			},
		],
	},
	T1_subtema3: {
		...baseSubTeamActivity,
		id: 3,
		title: "Planogramas",
		points: 35,
		numberOfTask: 2,
		nextActivity: tasksId.tema1.activities.subtema4,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema3/activityOne",
				title: "Planograma.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 35,
				pointsWon: 0,
				isOpen: true,
				url: "/home1/tema1/subtema3/activityTwo",
				title: "Evaluación.",
			},
		],
	},
	T1_subtema4: {
		...baseSubTeamActivity,
		id: 4,
		title: "Etiqueteo y PAR",
		points: 15,
		numberOfTask: 2,
		nextActivity: tasksId.tema1.activities.subtema5,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema4/activityOne",
				title: "Etiqueteo.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 15,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema4/activityTwo",
				title: "Productos de Alto Riesgo.",
			},
		],
	},
	T1_subtema5: {
		...baseSubTeamActivity,
		id: 5,
		title: "Preinventarios",
		points: 0,
		numberOfTask: 1,
		nextActivity: tasksId.tema1.activities.subtema6,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema5/activityOne",
				title: "Pre-inventario.",
			},
		],
	},
	T1_subtema6: {
		...baseSubTeamActivity,
		id: 6,
		title: "PromOXXO",
		points: 0,
		numberOfTask: 1,
		nextActivity: tasksId.tema1.activities.subtema7,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema6/activityOne",
				title: "PromOXXO.",
			},
		],
	},
	T1_subtema7: {
		...baseSubTeamActivity,
		id: 7,
		title: "Responsabilidades operativas",
		points: 5,
		numberOfTask: 2,
		nextActivity: tasksId.tema2.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 5,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema7/activityOne",
				title: "Seguimiento checklist",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home1/tema1/subtema7/activityTwo",
				title: "Enfoques mensuales",
			},
		],
	},
};

const activitiesInformationTeamTwo = {
	T2_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Operación de Roller",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 10,
		numberOfTask: 3,
		nextActivity: tasksId.tema2.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/introduction",
				title: "Partes claves de nuestra máquina Roller.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema1/activitytwo",
				title: "Mantén la máquina Roller limpia y en perfecto estado.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema1/activityThree",
				title: "Utensilios para la preparación de alimentos de la máquina Roller.",
			},
		],
	},
	T2_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Máquinas de café",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 70,
		numberOfTask: 8,
		isOpen: false,
		nextActivity: tasksId.tema3.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema2/activityone",
				title: "Pasos en la preparación del café.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema2/activitytwo",
				title: "Variedad de nuestros vasos disponibles.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema2/activityThree",
				title: "Explora los sabores y componentes de nuestra Capuchinera.",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema2/activityFour",
				title: "Utiliza correctamente la máquina Kobalto.",
			},
			{
				id: 5,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema3/activityFive",
				title: "Operación y funcionamiento de nuestra maquina Krea.",
			},
			{
				id: 6,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema2/activitySix",
				title: "Pasos detallados para la preparación de un delicioso Frappé.",
			},
			{
				id: 7,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema2/activitySeven",
				title: "Evaluación.",
			},
			{
				id: 8,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home2/tema2/subtema2/activityEight",
				title: "Conoce las máquinas de café de tu tienda.",
			},
		],
	}
}
const activitiesInformationTeamThree = {
	T3_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Limpieza y merma",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 95,
		numberOfTask: 3,
		nextActivity: tasksId.tema3.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/introduction",
				title: "Panera",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema1/activityTwo",
				title: "Panera: Tipos de pan",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 50,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema1/activityThree",
				title: "Panera: Evaluación",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema1/activityFour",
				title: "Quesera",
			},
			{
				id: 5,
				imgTask: imgs.imgActividad,
				points: 45,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema1/activityFive",
				title: "Quesera: Evaluación",
			},
		],
	},
	T3_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Máquina Warmer y Ejecución de salchikoxka",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 0,
		numberOfTask: 8,
		isOpen: false,
		nextActivity: tasksId.tema3.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema2/activityOne",
				title: "Warmer",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema2/activityTwo",
				title: "Warmer: Más información ",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema2/activityThree",
				title: "Ejecución de koxka y salchikoxka",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema2/activityFour",
				title: "Ejecución de koxka y salchikoxka: Caducidad de productos",
			},
			{
				id: 5,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema2/activityFive",
				title: "Ejecución de koxka y salchikoxka: Limpieza",
			},
		],
	},
	T3_subtema3: {
		...baseSubTeamActivity,
		id: 3,
		title: "Inocuidad",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 0,
		numberOfTask: 8,
		isOpen: false,
		nextActivity: tasksId.tema4.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema3/activityOne",
				title: "Inocuidad: Limpieza",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema3/activityTwo",
				title: "Limpieza: Exterior",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema3/activityThree",
				title: "Manejo de merma",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home3/tema3/subtema3/activityFour",
				title: "Misión final",
			},
		],
	}
}
const activitiesInformationThemeFour = {
	T4_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Conceptos básicos de caja",
		subtitle:
			"Exploraremos las actividades de un colaborador en tienda para que las apliques en tu día a día.",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 20,
		numberOfTask: 2,
		isOpen: false,
		nextActivity: tasksId.tema4.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema1/activityOne",
				title: "Descubriendo el Significado de un Servicio Memorable.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema1/activitytwo",
				title: "Los Pasos Clave para Ofrecer un Servicio Memorable.",
			},
		],
	},
	T4_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Herramientas de la caja",
		subtitle:
			"Exploraremos las actividades de un colaborador en tienda para que las apliques en tu día a día.",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 20,
		numberOfTask: 2,
		isOpen: false,
		nextActivity: tasksId.tema4.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema2/activityOne",
				title: "Aprende sobre tus herramientas de trabajo.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema2/activitytwo",
				title: "Mejora tu productividad con: Atajos del Teclado.",
			},
		],
	},
	T4_subtema3: {
		...baseSubTeamActivity,
		id: 3,
		title: "Formas de pago y venta sugerida",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 20,
		numberOfTask: 2,
		isOpen: false,
		nextActivity: tasksId.tema4.activities.subtema4,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema3/activityOne",
				title: "Formas de pago usuales de nuestros clientes.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema3/activityTwo",
				title: "Aprende sobre la venta sugerida.",
			},
		],
	},
	T4_subtema4: {
		...baseSubTeamActivity,
		id: 4,
		title: "Cobro de productos",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 100,
		numberOfTask: 5,
		isOpen: false,
		nextActivity: tasksId.tema4.activities.subtema5,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema4/activityOne",
				title: "¿Qué es el fondo fijo?",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema4/activityTwo",
				title: "Tu primera experiencia atendiendo a un cliente.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 40,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema4/activityThree",
				title: "¡Vamos por esa primera venta!",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema4/activityFour",
				title: "Manejando una cancelación de productos.",
			},
			{
				id: 5,
				imgTask: imgs.imgActividad,
				points: 60,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema4/activityFive",
				title: "Dominando los pagos con tarjeta.",
			},
		],
	},
	T4_subtema5: {
		...baseSubTeamActivity,
		id: 5,
		title: "Sinergia",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 10,
		numberOfTask: 2,
		isOpen: false,
		nextActivity: tasksId.tema4.activities.subtema6,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema5/activityOne",
				title: "Aprenderemos sobre el uso de cupones.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema5/activityTwo",
				title: "Entrega del cambio en compras con cupones.",
			},
		],
	},
	T4_subtema6: {
		...baseSubTeamActivity,
		id: 5,
		title: "Lavado de dinero",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 50,
		numberOfTask: 2,
		isOpen: false,
		nextActivity: tasksId.tema5.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema6/activityOne",
				title: "Etapas del lavado de dinero.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 50,
				pointsWon: 0,
				isOpen: false,
				url: "/home4/tema4/subtema6/activityOne",
				title: "Evaluación.",
			},
		],
	},
}
const activitiesInformationThemeFive = {
	T5_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Corresponsalías",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 60,
		numberOfTask: 2,
		isOpen: false,
		nextActivity: tasksId.tema5.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema1/activityOne",
				title: "10 Pasos clave para brindar un servicio de corresponsalías efectivo.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 50,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema1/activitytwo",
				title: "Evaluación.",
			},
		],
	},
	T5_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Retiro de efectivo",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 20,
		numberOfTask: 2,
		isOpen: false,
		nextActivity: tasksId.tema5.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema2/activityOne",
				title: "Pasos para el retiro de efectivo.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema2/activitytwo",
				title: "Realiza un correcto retiro de efectivo.",
			},
		],
	},
	T5_subtema3: {
		...baseSubTeamActivity,
		id: 3,
		title: "Remesas",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 40,
		numberOfTask: 3,
		isOpen: false,
		nextActivity: tasksId.tema5.activities.subtema4,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema3/activityOne",
				title: "Observaciones para el retiro de remesas.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema3/activityTwo",
				title: "Realiza un correcto retiro de remesas.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 40,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema3/activityTwo",
				title: "Evaluación.",
			},
		],
	},
	T5_subtema4: {
		...baseSubTeamActivity,
		id: 4,
		title: "Envío de OXXO a OXXO.",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 10,
		numberOfTask: 1,
		isOpen: false,
		nextActivity: tasksId.tema6.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: "/home5/tema5/subtema4/activityOne",
				title: "Pasos para enviar correctamente, dinero de OXXO a OXXO.",
			},
		],
	},
}

const activitiesInformationTeamSix = {
	T6_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Tiempo Aire Electrónico (TAE)",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 10,
		numberOfTask: 1,
		nextActivity: tasksId.tema6.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 10,
				pointsWon: 0,
				isOpen: false,
				url: " ",
				title: "Pago de servicios agua y drenaje",
			},
		],
	},
	T6_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Tiempo Aire Electrónico (TAE) con QR",
		points: 50,
		numberOfTask: 3,
		nextActivity: tasksId.tema6.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema2/activityOne",
				title: "Pasos para una recarga de (TAE).",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema2/activityTwo",
				title: "Realiza una recarga de (TAE) en tiempo real con un cliente.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 50,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema2/activityThree",
				title: "Evaluación.",
			},
		],
	},
	T6_subtema3: {
		...baseSubTeamActivity,
		id: 3,
		title: "Tiempo Aire Electrónico (TAE) con QR",
		points: 30,
		numberOfTask: 3,
		nextActivity: tasksId.tema6.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema3/activityOne",
				title: "¿Qué es una recarga de (TAE) código QR?",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema3/activityTwo",
				title: "Pasos para una recarga de (TAE) con QR.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 30,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema3/activityThree",
				title: "Evaluación.",
			},
		],
	},
	T6_subtema4: {
		...baseSubTeamActivity,
		id: 4,
		title: "OXXO Pay",
		points: 30,
		numberOfTask: 3,
		nextActivity: tasksId.tema6.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema4/activityOne",
				title: `Pasos para realizar el cobro con "OXXO PAY".`,
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema4/activityTwo",
				title: `Simulación de cobro utilizando "OXXO PAY".`,
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 30,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema4/activityThree",
				title: "Evaluación.",
			},
		],
	},
	T6_subtema5: {
		...baseSubTeamActivity,
		id: 5,
		title: "Spin by OXXO",
		points: 20,
		numberOfTask: 3,
		nextActivity: tasksId.tema6.activities.subtema3,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema5/activityOne",
				title: `Beneficios de Spin by OXXO.`,
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema5/activityTwo",
				title: `Cómo acumular puntos en Spin by OXXO.`,
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema5/activityThree",
				title: "Cómo canjear puntos en Spin by OXXO.",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 20,
				pointsWon: 0,
				isOpen: false,
				url: "/home6/tema6/subtema5/activityFour",
				title: "Evaluación.",
			},
		],
	}
}

const activitiesInformationTeamSeven = {
	T7_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Venta Responsable",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 0,
		numberOfTask: 2,
		nextActivity: tasksId.tema7.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home7/tema7/subtema1/activityOne",
				title: "Requisitos para una venta responsable.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home7/tema7/subtema2/activityTwo",
				title: "Normativas legales en la venta responsable.",
			},
		],
	},
	T7_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Control de efectivo.",
		points: 70,
		numberOfTask: 4,
		nextActivity: tasksId.tema8.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home7/tema7/subtema2/activityOne",
				title: "¿Qué es un corte X?",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home7/tema7/subtema2/activityTwo",
				title: "Resuelve un corte X.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 70,
				pointsWon: 0,
				isOpen: false,
				url: "/home7/tema7/subtema2/activityThree",
				title: "Retiro parcial de efectivo.",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home7/tema7/subtema2/activityFour",
				title: "Partes clave para un corte Z.",
			},
		],
	},

}

const activitiesInformationTeamEight = {
	T8_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "Enfoques de Protección Patrimonial.",
		insignia: imgs.insignia,
		activityimg: imgs.imgActividad,
		points: 0,
		numberOfTask: 1,
		nextActivity: tasksId.tema8.activities.subtema2,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home8/tema8/subtema1/activityOne",
				title: "Requisitos para una venta responsable.",
			},
		],
	},
	T8_subtema2: {
		...baseSubTeamActivity,
		id: 2,
		title: "Situaciones de riesgo",
		points: 30,
		numberOfTask: 5,
		nextActivity: tasksId.tema9.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home8/tema8/subtema2/activityOne",
				title: "Regla de Oro para tu seguridad personal.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home8/tema8/subtema2/activityTwo",
				title: "¿Qué es el centro de  control?",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home8/tema8/subtema2/activityThree",
				title: "Aprende sobre situaciones de riesgo.",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home8/tema8/subtema2/activityFour",
				title: "Medidas preventivas en punto de venta.",
			},
			{
				id: 5,
				imgTask: imgs.imgActividad,
				points: 30,
				pointsWon: 0,
				isOpen: false,
				url: "/home8/tema8/subtema2/activityFive",
				title: "Evaluación.",
			},
		],
	},

}
const activitiesInformationTeamNine = {
	T9_subtema1: {
		...baseSubTeamActivity,
		id: 1,
		title: "SASSO",
		points: 30,
		numberOfTask: 5,
		// nextActivity: tasksId.tema9.activities.subtema1,
		task: [
			{
				id: 1,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home9/tema9/subtema1/activityOne",
				title: "Aprende sobre SASSO y sus características.",
			},
			{
				id: 2,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home9/tema9/subtema1/activityTwo",
				title: "Identifica los principales riesgos que existen en Tienda.",
			},
			{
				id: 3,
				imgTask: imgs.imgActividad,
				points: 0,
				pointsWon: 0,
				isOpen: false,
				url: "/home9/tema9/subtema1/activityThree",
				title: "Reglas de Oro, para la prevención de accidentes.",
			},
			{
				id: 4,
				imgTask: imgs.imgActividad,
				points: 30,
				pointsWon: 0,
				isOpen: false,
				url: "/home9/tema9/subtema1/activityFour",
				title: "Evaluación.",
			},
		],
	},

}

export const activitiesInformationInit = {
	...activitiesInformationTeamOne,
	...activitiesInformationTeamTwo,
	...activitiesInformationTeamThree,
	...activitiesInformationThemeFour,
	...activitiesInformationThemeFive,
	...activitiesInformationTeamSix,
	...activitiesInformationTeamSeven,
	...activitiesInformationTeamEight,
	...activitiesInformationTeamNine,
};
